import request from '@/utils/request'

const goodsReportApi = {
  trade_goods_report_list: '/trade/goods_report/',
  trade_goods_report_create: '/trade/goods_report/',
  trade_goods_report_update: '/trade/goods_report/',
  trade_goods_report_delete: '/trade/goods_report/',
  trade_goods_report_archived: '/trade/goods_report_archived/',
  trade_goods_report_attachment: '/trade/goods_report_attachment/'
}

/**
 * 列表
 */
export function goods_report_list (parameter) {
  return request({
    url: goodsReportApi.trade_goods_report_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function goods_report_create (parameter) {
  return request({
    url: goodsReportApi.trade_goods_report_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function goods_report_update (parameter, goods_report_id) {
  return request({
    url: goodsReportApi.trade_goods_report_update + goods_report_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function goods_report_delete (goods_report_id) {
  return request({
    url: goodsReportApi.trade_goods_report_delete + goods_report_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function goods_report_archived (parameter) {
  return request({
    url: goodsReportApi.trade_goods_report_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
* 担保合同附件列表
* @param parameter
* @returns {AxiosPromise}
*/
export function goods_report_attachment_list (parameter) {
  return request({
    url: goodsReportApi.trade_goods_report_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 担保合同附件添加
 */
export function goods_report_attachment_create (parameter) {
  return request({
    url: goodsReportApi.trade_goods_report_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 担保合同附件删除
 */
export function goods_report_attachment_delete (contract_attachment_id) {
  return request({
    url: goodsReportApi.trade_goods_report_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
